export interface UserProfile {
    id:string,
    name:string,
    email:string,
    systemRole:string,
    isActive:boolean,
}

export enum SystemRole {
    ADMIN = 'admin',
    USER = 'user',
}